import { Pipe, PipeTransform } from '@angular/core';

import { tiposFretes } from '../tipo-frete';

@Pipe({
    name: 'tipoFreteDescricao'
})
export class TipoFreteDescricaoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = tiposFretes.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return tiposFretes[index].descricao;
        }
        return '';
    }
}
